import * as Yup from "yup";


export const AdminSchema = Yup.object({
    user: Yup.string().required(" Enter User Name"),
    password: Yup.string().required(" Enter Your Password"),
});